<template>

	<div>

		<section class="outer-pad">

			<Table 
				:headings="headings" 
				:items="table.items" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:sorted="table.sorted"
				:searchSetup="searchSetup" 
				emptyLabel="No users were found"
				:loading="!fetched"
				loadingText="Fetching users..."
				name="admin-users"
				@pagination="pagination"
				@sort="sort"
				@search="search"
				@addSomeCredits="addSomeCredits"
				@addAnalysisCredits="addAnalysisCredits"
				@deleteUser="deleteUser"
				@isReal="isReal"
				@loginAs="loginAs"
				@reset="resetUser"
			/>

		</section>

		<AddCredits 
			v-if="showAddCredits" 
			@save="saveCredits" 
			@close="closeAddSomeCredits" 
		/>

		<AddAnalysisCredits
			v-if="addAnalysisCreditsToUser"
			:userId="addAnalysisCreditsToUser"
			@close="closeAddAnalysisCredits"
			@reloadUsers="submitSearch"
		/>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import general from './../../utils/general'
import ApiService from './../../services/api.service'
import Table from './../../components/Table.vue'
import TableButton from './../../components/Display/TableButton.vue'
import AddCredits from './../../components/AddCredits.vue'
import AddAnalysisCredits from './../../components/AddAnalysisCredits.vue'
import { TokenService } from './../../services/storage.service'
export default {
	name: 'AdminUsers',
	components: {
		Table,
		AddCredits,
		AddAnalysisCredits
	},
	data() {
		return {
			fetched: false,
			showHeadings:{},
			addCreditsTo:null,
			showAddCredits: false,
			addAnalysisCreditsToUser: null,
			table: {
				items:[],
				page: 1,
				pages: 1,
				sorted: { firstName: 1 },
				search: {}
			}
		}
	},
	computed: {

		...mapState('general',['dateTimeFormat','dateFormat','products','tableSortingInfo']),

		productsProcessed () {

			if ( Object.keys(this.products).length === 0 ) return [];

			let r = [];

			this.products.keywords.forEach ( product => {

				let month = product.prices.find( p => p.frequency === 'month' && !p.hidden ),
					year = product.prices.find( p => p.frequency === 'year' && !p.hidden );

				r.push({
					value: { 
						product: product._id, 
						month: month, 
						year: year,
						level: month.level
					},
					label: product.labelFull
				});

			});

			return r;

		},

		searchSetup () {

			let searchSetup = { 
				name: { type: 'text', placeholder: '', showLabel: 'Name' },
				searchText: { type: 'text', placeholder: '', showLabel: 'Email' },
				created: { type: 'date-range', placeholder: '', showLabel: 'Signup Date' },
				accountType: { 
					type: 'select', 
					multi: true, 
					showLabel: 'Account Type', 
					items: [ 
						{ value: 'trial-no-card', label: 'Trial (signup only)' },
						{ value: 'trial', label: 'Trial (entered card details)' },
						{ value: 'no-subscription', label: 'No Subscriptions (Trial Ended)' },
						{ value: 'subscription', label: 'Subscription' },
						{ value: 'cancelled', label: 'Cancelled' },
						{ value: 'cancelled-not-expired', label: 'Cancelled but not expired' },
						{ value: 'cancelled-expired', label: 'Cancelled and expired' }
					]
				},
				otherOptions: { 
					type: 'select', 
					multi: true, 
					showLabel: 'Other Filters', 
					items: [ 
						//{ value: 'no-keywords', label: 'Never Added Any Keywords' },
						{ value: 'real-users', label: 'Real Users Only' },
						{ value: 'gifted', label: 'Gifted Keywords' }
					]
				},
				frequency: { 
					type: 'select', 
					multi: false, 
					showLabel: 'Charge Frequency', 
					items: [ 
						{ value: 'month', label: 'Monthly' },
						{ value: 'year', label: 'Yearly' }
					]
				},
				package: { 
					type: 'select', 
					multi: true, 
					showLabel: 'Package', 
					items: this.productsProcessed
				}
			};

			return searchSetup;

		},
		headings () {

			let headings = {
				firstName: { value: 'Name', alignHeading: 'left', alignCell: 'left', sort: -1 }, 
				email: { value: 'Email', alignHeading: 'left', alignCell: 'left', sort: 1 },
				created: { value: 'Signup', alignHeading: 'left', alignCell: 'left', sort: 1, dateFormat: this.dateFormat }, 
				projectCount: { value: 'Projects', alignHeading: 'left', alignCell: 'left' }, 
				keywordCounts: { value: 'Active/All KWs', alignHeading: 'left', alignCell: 'left' }, 
				subscription: { value: 'Subscr.', alignHeading: 'left', alignCell: 'left', emptyCell: 'None' },
				credits: { value: 'KW Credits All/Gifted', alignHeading: 'left', alignCell: 'left', click: 'addSomeCredits', 'clickVars': ['_id'] },
				contentKeywordCount: { value: 'C&Ks', alignHeading: 'left', alignCell: 'left' },
				analysisCredits: { value: 'An. Creds', alignHeading: 'left', alignCell: 'left', click: 'addAnalysisCredits', 'clickVars': ['_id'] },
				lastActive: { value: 'Active', alignHeading: 'left', alignCell: 'left', dateFormat: this.dateFormat }, 
				accessAverage: { value: 'Access', alignHeading: 'left', alignCell: 'left' }, 
				loginAs: { value: 'Login', component: TableButton, event: 'loginAs', valueForFilter: 'Login As' },
				real: { value: 'Real', component: TableButton, event: 'isReal', valueForFilter: 'Real User' },
				source: { value: 'Source' },
				heardAbout: { value: 'Heard About' },
				//delete: { component: TableButton, event: 'deleteUser', hideHeading: true, valueForFilter: 'Archive' }
			};

			if ( window.location.hostname !== 'app.rankcaddy.io' ) {

				headings.reset = { value: '', component: TableButton, event: 'reset', valueForFilter: 'Reset' };

			}

			return headings;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		resetUser ({_id,email}) {

			let m = "Reset "+email+"? (delete any stripe activity)";

			this.$dialog
				.confirm(  m, { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText(true);

					ApiService.post( 'admin/users/reset/' + _id )
					.then( function( response ) {

						this.submitSearch ();
						this.$snotify.success(response.data, 'Reset User');

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();
						this.$snotify.error(err.response.data.error, 'Rest User');

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		addAnalysisCredits (info) {

			this.addAnalysisCreditsToUser = info._id;

		},

		closeAddAnalysisCredits (info) {

			if ( typeof info === 'object' && typeof info.reload !== 'undefined' ) {
				
				this.submitSearch();

			}

			this.addAnalysisCreditsToUser = null;
			general.modalClose();

		},

		addSomeCredits (info) {

			this.showAddCredits = true;
			this.addCreditsTo = info._id;

		},

		closeAddSomeCredits () {

			this.showAddCredits = false;
			general.modalClose();

		},

		saveCredits (info) {

			this.showAddCredits = false;

			this.updateLoadingText("Adding some credits...");

			ApiService.post( 'admin/users/add-credits', { credits: info, user: this.addCreditsTo } )
			.then( function( info ) {

				this.submitSearch ();
				this.addCreditsTo = null;

			}.bind(this))
			.catch( function(err) {

				this.updateLoadingText();
				this.$snotify.error(err.response.data.error, 'Add Credits');

			}.bind(this));

		},

		isReal ({_id,real,name}) {

			let m = name+" is a real user?";

			if ( !real ) m = name+" is not a real user?";

			this.$dialog
				.confirm(  m, { okText: 'That\'s right', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText("One moment...");

					ApiService.post( 'admin/users/real/' + _id + '/' + ( real === true ? 1 : 0 ) )
					.then( function( response ) {

						this.submitSearch ();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();
						this.$snotify.error(err.response.data.error || 'Unknown Error', 'Real User');

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		loginAs ({_id,name}) {

			let m = "Login As "+name+"?";

			this.$dialog
				.confirm(  m, { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText("One moment...");

					ApiService.post( 'admin/users/login-as/' + _id )
					.then( function( response ) {

						this.updateLoadingText();
						TokenService.saveToken(response.data.access_token)
			            TokenService.saveId(response.data.uid)
			            TokenService.saveAccountId(response.data.account)
			            TokenService.saveInitials(response.data.initials)
			            TokenService.saveName(response.data.name)
						TokenService.saveFirstName(response.data.firstName)
			            if ( typeof response.data.sessionInfo !== 'undefined' ) 
							TokenService.saveExtraInfo(response.data.sessionInfo)
						else 
							TokenService.removeExtraInfo();
			            TokenService.saveRefreshToken(response.data.refresh_token);
						
			        	window.location.assign('/');

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();
						this.$snotify.error(err.response.data.error, 'Login As...');

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		deleteUser (info) {

			this.$dialog
				.confirm( "Are you sure you want to archive " + info.email + "? (YOU CURRENTLY NEED TO MANUALLY REMOVE THEM FROM MAILJET AS WELL)", { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText("Archiving " + info.email + ", one moment...");

					ApiService.delete( 'admin/users/' + info._id )
					.then( function( info ) {

						this.submitSearch ();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();
						this.$snotify.error(err.response.data.error, 'Archive User');

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		sort(info) {

			Vue.set( this.table, 'sorted', info );
			Vue.set( this.table, 'page', 1 );
			if ( info.init ) { delete this.table.sorted.init; return; }
			this.submitSearch('sort');

		},

		search(info) {

			this.table.page = 1;
			this.table.search = info;
			this.submitSearch('search');

		},

		pagination(info) {

			this.table.page = info.page;
			this.submitSearch('pagination');

		},

		submitSearch (label) {

			let vars = { 
				page: this.table.page, 
				search: this.table.search, 
				sorted: this.table.sorted 
			};

			ApiService.post( 'admin/users', vars )
	        .then( function( info ) {

	            let tableInfo = this.table;

				tableInfo.items = info.data.items;
				tableInfo.count = info.data.count;
				tableInfo.pages = info.data.pages;
				tableInfo.page = info.data.page;

				if ( info.sorted ) {

					tableInfo.sorted = info.sorted;

				}

				this.fetched = true;

				Vue.set(this, 'table', tableInfo);

				this.updateLoadingText();

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

		}
		
	},
	created() {

		if ( this.tableSortingInfo['admin-users'] ) {

			Vue.set( this.table, 'sorted', this.tableSortingInfo['admin-users'] );

		}

		this.submitSearch();

	}
}
</script>
